import { mapGetters, mapActions } from "vuex";
import { types as VI } from "@/store/vi";
import shareTip from "@/components/shareTip.vue";
import couponItem from "@/components/couponItem.vue";
import floatingStrip from "@/components/floatingStrip.vue";
import {
  adCart,
  checkCart,
  getGoodsDetail,
  getGoodsAssist,
  storeDetail,
  getGoodsInfo,
  getComments,
  getAppShareURL,
  queryCoupon,
  getCoupon,
  getAppShareURLApi,
  getShareImg,
  pilotCityList,
  addOrUpdateApi,
  findListing,
  viPopFor919Api,
  queryActCodeByUsrRoleAndThemeCodeApi,
  getGoodsDetailApp,
  getActBanner,
  shengmingTixingApi
} from "@/libs/api.js";
import { debounce } from "@/libs/common.js";
import { getShareInfo } from "@/libs/wxShare.js";
import { types as Home } from "@/store/home";
import html2canvas from "html2canvas";
import Qs from "qs";
import redPacket from "@/components/redpacket.vue"

const getters = mapGetters({
  getViStorage: VI.VI_STORAGE,
  getCurrentCityByMin: Home.CURRENT_CITY,
});
const actions = mapActions({
  setViStorage: VI.VI_STORAGE,
});

export default {
  name: "itemPage",
  components: { shareTip, couponItem, redPacket ,floatingStrip},
  data() {
    return {
      showRed: false,
      oldCouObj: [],
      uleUrl: "",
      goodsDetail: {
        colors: [],
      },
      tabActive: 0,
      boxHeight: "", // 设置banner盒子高度
      bannerImages: "",
      bannerCurrent: 0,
      active: 0,
      sizeActive: 0,
      listingId: "", // 商品id
      storage: 0,
      colorName: "",
      sizeName: "",
      shipTime: "", // 预售信息
      saleRangeList: [], // 配送地区
      price: 0, // 商品销售价格
      mkPrice: 0, // 市场价
      makePrice: 0, // 赚佣金
      limit: false,
      prodCount: 1, //起购数量
      minNum: 1, //最小数量
      // sellNum: 12, // 接口数据缺失  销售数量暂时不显示
      cartNum: null, // 购物车数量
      serviceState: false, // 客服状态
      serviceUrl: "", // 客服链接
      goodsDesc: "", // 商品详情介绍
      paramsDesc: [], // 商品参数介绍
      statement: '', // 声明与提醒
      prodItems: false, // 规格选择弹框
      // 优惠券
      showCouponList: false,
      chosenCoupon: -1, // 当前选中优惠券的索引
      coupons: [],
      disabledCoupons: [], // 不能使用或不能领取的优惠券
      checkedCoupon: false, // 弹框里checked是否显示
      couponPopTip: true, // 优惠券弹框
      listPromotionDesc: "", //活动信息
      // 评论
      comments: [],
      date: "",
      comLoading: true, //评论loading
      getShareId: "", // 连接里接收的分享id,用于下单
      shareId: "", // 分享人的分享id，用于记录分享
      store_id: "", // 此id也是分享人的用户id，后端定义名字混乱和店铺名字一样，标注一下，lj后端
      showTip: false,
      client_type: "wap_ylxds",
      freshActType: "", //试点城市下单标识
      shareTitle: "", //分享title
      shareImg: "", //分享图片
      // iswxMiniprogram: false, // 小程序环境判断
      shareBtnStatus: true, //  分享按钮控制
      // 记录直播渠道参数
      union_id: null,
      union_ref: null,
      // 店铺相关信息
      storeInfo: {},
      //是否是有了农品
      np: false,
      ys: false,
      isShowWrap: false,
      activeListingTag: "",
      jsonpNum: 0,
      countdown: "", //倒计时
      isActivityStart: true, //活动是否开始
      noActivity: false, //活动预热未开始或已结束
      startTime: 0,
      endTime: 0,
      nowTime: 0,
      isLogin: false,
      targetUrl: `https://h5.${this.$uleUrl()}/yxd/community`,
      ylyx_commodity_current_price: "",
      ylyx_commodity_original_price: "",
      isShowCar: false, // 是否显示加入购物车
      canBuy: true, // 是否显示购买按钮
      appName:'',
      hd919Data:"",//浮层数据
      rainImg:'',
      rainUrl:'',
      deliveryAreaId:'',
      palletIdShow:false,
      isShowFloatStrip:false,
      isShowPc:false,
      showActBanner:false,
      actBanImgUrl:'',
      banInfo:'',
      detailTab: 1, // 详情页tab切换
      adid:''
    };
  },
  computed: {
    ...getters,
    creatbanner() {
      return this.bannerImages;
      // return this.bannerImages.replace(/.jpg/g, '_xl.jpg').split("|*|")
    },
    allCoupons() {
      return [...this.coupons, ...this.disabledCoupons];
    },
  },
  methods: {
    ...actions,
    handleSwiper(){
      if(this.isPC()){
        this.$refs.swiperItem.next()
      }
    },
    picNext(){
      this.$refs.swiperItem.next()
    },
    picPrv(){
      this.$refs.swiperItem.prev()
    },
    jumpActBanner(){
      let _this = this;
      if(_this.banInfo?.h5Path){
        window.location.href = _this.banInfo.h5Path;
      }else{
        if (this.$browser().version >= 327) {
          dsBridge.call("jumpWxMiniProgram", { "path": _this.banInfo.mpPath, "originalId": _this.banInfo.mpOriginalId })
        } else {
          this.$toast('抱歉,您的APP版本过低,请下载最新版APP');
        }
      }
    },
    actBanner() {
      let _this = this;
      getActBanner().then(res=>{
        try {
          _this.actBanImgUrl = res.ylyx_vi_banner.data[0].imgUrl;
          _this.banInfo = {mpAppId:res.ylyx_vi_banner.data[0].mpAppId,mpOriginalId:res.ylyx_vi_banner.data[0].mpOriginalId,mpPath:res.ylyx_vi_banner.data[0].mpPath,clients_type:res.ylyx_vi_banner.data[0].clients_type};
          let banInfo = _this.banInfo
          if(banInfo.clients_type && (banInfo.clients_type.indexOf('0') > -1 || banInfo.clients_type.indexOf('1') > -1)){  //全部和app
            if(_this.actBanImgUrl && banInfo.mpAppId && banInfo.mpOriginalId && banInfo.mpPath){
              _this.showActBanner = true;
            }else{
              if(res.ylyx_vi_banner.data[0].h5Path){
                _this.showActBanner = true;
                _this.banInfo.h5Path = res.ylyx_vi_banner.data[0].h5Path;
              }
            } 
          }           
        } catch (error) {
          
        }
      })
    },
    handleBackIndex(){
      if(this.$route.query.from == 'categoryList' || this.$route.query.from == 'cartList'){
        window.history.go(-1);
      }else{
        window.location.href = "ulemobile://ulePopView";
      }
    },
    // 红包雨弹层
    getRainFloat() {
      queryActCodeByUsrRoleAndThemeCodeApi({ channel: 'wap_ylxdsq' }).then(res => {
        console.log('res=======', res);
        if (res.code == '0000') {
          if (res.data) {
            let userRole = res.data[0].userRole;
            let conformImg = '',
              conformUrl = '',
              nullImg = '',
              nullUrl = '';
            res.data.forEach(item => {
              // vip会员
              if (item.userLimit == '103' && (userRole == '1' || userRole == '2')) {
                if (item.fieldInfos.length > 0) {
                  conformImg = item.float_pic;
                  conformUrl = item.activityUrl;
                }
              }
              // 普通会员
              else if (item.userLimit == '0' && (userRole == '0' || userRole == '3')) {
                if (item.fieldInfos.length > 0) {
                  conformImg = item.float_pic;
                  conformUrl = item.activityUrl;
                }
              }
              // 全部默认
              if (item.userLimit == null || item.userLimit == '') {
                if (item.fieldInfos.length > 0) {
                  if (userRole == '1' || userRole == '2') {
                    nullImg = item.float_pic;
                  } else {
                    nullImg = item.float_pic;
                  }
                  nullUrl = item.activityUrl;
                }
              }
            });
            this.rainImg = conformImg || nullImg || '';
            this.rainUrl = conformUrl || nullUrl || '';

            if(this.rainUrl) {
              if (this.rainUrl.indexOf('?') > -1) {
                this.rainUrl = `${this.rainUrl}&storeid=${this.store_id}&shareId=${this.$route.query.shareId}`;
              } else {
                this.rainUrl = `${this.rainUrl}?storeid=${this.store_id}&shareId=${this.$route.query.shareId}`;
              }
            }
          }
        } 
        if(this.rainImg == '') {
          this.get919Data();//获取浮层展示数据
        }
      });
    },
    // 红包雨点击
    handleTobuoy() {
      if (this.rainUrl) {
        console.log('跳转链接=====', this.rainUrl);
        window.location.href = this.rainUrl;
      }
    },
    onChangeBanner(index) {
      this.bannerCurrent = index;
    },
    resizeEvent() {
      this.boxHeight = "height:" + this.$el.clientWidth + "px";
    },
    // 颜色切换
    changColor(index, itemId, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.active = index;
      }
      if (this.minNum > 1) {
        this.prodCount = this.minNum;
      } else {
        this.prodCount = 1;
      }

      if (this.sizeActive >= this.goodsDetail.colors[index]["items"].length) {
        this.sizeActive = this.goodsDetail.colors[index]["items"].length - 1;
        this.goodsDetail.defItemId = this.goodsDetail.colors[index]["items"][
          this.sizeActive
        ].itemId;
      }
      this.bannerImages = this.goodsDetail.colors[index]["items"][
        this.sizeActive
      ].imageList;
      this.goodsDetail.defItemId = this.goodsDetail.colors[index]["items"][
        this.sizeActive
      ].itemId;
      this.storage = this.goodsDetail.colors[index]["items"][
        this.sizeActive
      ].itemStorage;
      this.colorName = this.goodsDetail.colors[index].colorName;
      this.sizeName = this.goodsDetail.colors[this.active]["items"][0].attrName;
      // this.maxPrice、this.price 如果有一品多价也在此处处理
      if (
        !this.noActivity &&
        (this.goodsDetail.promotionIds.indexOf("6202") > -1 ||
          this.goodsDetail.promotionIds.indexOf("6203") > -1)
      ) {
        //限时特价  新人礼特价
        this.price = this.goodsDetail.colors[this.active]["items"][
          this.sizeActive
        ].membershipPrice;
      } else {
        this.price = this.goodsDetail.colors[this.active]["items"][
          this.sizeActive
        ].itemSalPrice;
      }
      this.maxPrice = this.goodsDetail.colors[this.active]["items"][
        this.sizeActive
      ].itemMarketPrice;
    },
    // 规格切换
    changSize(index, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.sizeActive = index;
        this.bannerImages = this.goodsDetail.colors[this.active]["items"][
          index
        ].imageList;
        this.goodsDetail.defItemId = e.target.getAttribute("itemId");
        this.storage = e.target.getAttribute("storage");
        this.sizeName = this.goodsDetail.colors[this.active]["items"][
          index
        ].attrName;
        this.ylyx_commodity_current_price = this.goodsDetail.colors[
          this.active
        ]["items"][index].itemSalPrice;
        this.ylyx_commodity_original_price = this.goodsDetail.colors[
          this.active
        ]["items"][index].itemMarketPrice;
        // this.maxPrice、this.price 如果有一品多价也在此处处理
        if (
          !this.noActivity &&
          (this.goodsDetail.promotionIds.indexOf("6202") > -1 ||
            this.goodsDetail.promotionIds.indexOf("6203") > -1)
        ) {
          //限时特价  新人礼特价
          this.price = this.goodsDetail.colors[this.active]["items"][
            index
          ].membershipPrice;
        } else {
          this.price = this.goodsDetail.colors[this.active]["items"][
            index
          ].itemSalPrice;
        }
        this.maxPrice = this.goodsDetail.colors[this.active]["items"][
          index
        ].itemMarketPrice;
        if (this.limit) {
          // 商品有限购
          if (Number(this.goodsDetail.limitNum) > Number(this.storage)) {
            // 限购数量超出库存时取最小
            this.goodsDetail.limitNum = this.storage;
          } else {
            // this.limitNum = limitNum
          }
        } else {
          this.storage = e.target.getAttribute("storage");
          if (Number(this.minNum) > Number(this.storage)) {
            // 最少购买数大于库存 ,团购商品存在这个问题
            this.$toast("商品已售罄");
            this.prodCount = this.storage;
          }
        }
      }
      if (Number(this.prodCount) > Number(this.storage)) {
        this.prodCount = this.storage;
      }
    },
    onChange(index) {
      // let channelCode = "";
      // if (this.$browser().miniprogram) {
      // 	// 小程序
      // 	channelCode = "YLXD_COMMUNITY_VERSION_MINI_APPS";
      // } else if (this.$browser().ylxdsq || this.$browser().yzgxd) {
      // 	// app
      // 	channelCode = "YLXD_COMMUNITY_VERSION_APP";
      // } else {
      // 	channelCode = "YLXD_COMMUNITY_VERSION_H5";
      // }
      // if (index >= 0 && this.coupons[index].couponWallFlag == 1) {
      // 	// 领取优惠券
      // 	let getCouponData = {
      // 		batchId: this.coupons[index].id,
      // 		receiveAddress: location.href,
      // 		storeId: this.goodsDetail.uleStoreId,
      // 		receiveChannelCode: channelCode, // app_ylxdsq，miniwx_ylxdsq，
      // 	};
      // 	this.getCoupon(getCouponData, index);
      // 	this.showCouponList = false;
      // } else if (index === -1) {
      // this.showCouponList = false;
      // }
      // 记录进页面弹优惠券
      let couponPopObj = {};
      couponPopObj[this.listingId] = this.date;
      if (this.checkedCoupon) {
        this.setViStorage(couponPopObj);
      }
    },
    getStatement () {
      shengmingTixingApi().then((res) => {
        let shenming = "<h3>声明与提醒：</h3>";
        if (res.vi_shengmingTixing && res.vi_shengmingTixing.length > 0) {
          for (var i = 0; i < res.vi_shengmingTixing.length; i++) {
            shenming += "<p>" + res.vi_shengmingTixing[i].title + "</p>";
          }
        }
        this.statement = shenming;
      });
    },
    getGoodsDetail(listingId,params) {
      console.log('商品详情参数params====',params)
      // 优鲜环境
      if(this.$browser().ylxdsq || this.$browser().ulemax){
        let _this = this;
        window.dsBridge.call("getPilotStatus", {
          ios_action: "getPilotStatusResult",
          android_action: "getPilotStatusResult",
        });
        window.dsBridge.register("getPilotStatusResult", function(s) {
          console.log('是否试点ssssss======1',s)
          console.log('是否试点ssssss======2',!s)
          if(!s){
            _this.isShowFloatStrip = true;
            console.log('进来了111,',_this.isShowFloatStrip)
          }
          getGoodsDetailApp(params,s).then((res) => {
            console.log('商品返回内容',res)
            if (res && (res.returnCode === "0000" || res.code === "0000")) {
              console.log('res.data.palletId====',res.data.palletId)
              if(!res.data.palletId && s){
                _this.palletIdShow = true;
              }
              if(s){
                _this.freshActType = '1'
              }
              console.log('palletIdShow',_this.palletIdShow)
              _this.shipTime = res.data.shipTime;
              let areaArr = JSON.parse(
                (res.data.saleRange || "[]").replace(/全部/g, "")
              );
              // console.log(areaArr);
              if (areaArr.length > 0) {
                areaArr.forEach((element) => {
                  if (element.cityName) {
                    if (element.cityName.indexOf(element.provinceName) > -1) {
                      element.provinceName = "";
                    }
                    if (element.countryName) {
                      _this.saleRangeList.push(
                        `${element.provinceName}${element.cityName}${element.countryName}`
                      );
                    } else {
                      _this.saleRangeList.push(
                        `${element.provinceName}${element.cityName}`
                      );
                    }
                  } else {
                    _this.saleRangeList.push(element.provinceName);
                  }
                  // 	if (element.cityName.indexOf(element.provinceName) > -1) {
                  // 		element.provinceName = "";
                  // 		if (element.countryName) {
                  // 			_this.saleRangeList.push(`${element.provinceName}${element.cityName}${element.countryName}`);
                  // 		} else {
                  // 			_this.saleRangeList.push(`${element.provinceName}${element.countryName}`);
                  // 		}
                  // 	} else {
                  // 		_this.saleRangeList.push(element.provinceName);
                  // 	}
                });
                // console.log(_this.saleRangeList);
              }
              let idArr = []; //商品促销标识集
              res.data.promotionList.map((item) => {
                idArr.push(item.id);
              });
              // if (~idArr.indexOf("50")) {
              //   // 团购
              //   location.href = `https://item.${_this.$uleUrl()}/mitem/item/view/${listingId}`;
              // } else 
              if (~idArr.indexOf("46")) {
                // 秒杀
                location.href = `https://item.${_this.$uleUrl()}/mitem/item/view/${listingId}`;
              }
              let data = res.data;
              _this.goodsDetail = data;
              if(data.presaleDesc){
                _this.goodsDetail.presaleDesc=JSON.parse(data.presaleDesc);
              }
              console.log('商品详情data====',_this.goodsDetail)
              _this.paramsDesc = data.standardAttributeList ? JSON.parse(data.standardAttributeList) : [];
              if (_this.freshActType == 1 && _this.paramsDesc.length > 0) {
                // 试点只展示4个属性
                _this.paramsDesc = _this.paramsDesc.filter(item => {
                  return item.attrName == '储存方式' || item.attrName == '产地' || item.attrName == '生产日期' || item.attrName == '保质期'
                })
              }
              console.log('价格sssss=====',s)
              console.log('价格data=====',data)
              _this.getStatement()
              _this.getGoodsAssist(listingId, data,s);
              //神策埋点
              window.uleStatUtil &&
                window.uleStatUtil.sendSensorTrack("ylyx_CommodityDetailPageView", {
                  item_id: data.listId,
                  ylyx_commodity_name: data.listName,
                  ylyx_commodity_original_price: data.sharePrice,
                  ylyx_commodity_current_price: data.marketPrice,
                });
              document.title = _this.goodsDetail.listName;
              if (_this.goodsDetail.listPromotionDesc) {
                _this.listPromotionDesc = JSON.parse(
                  _this.goodsDetail.listPromotionDesc
                );
                let nowTime = new Date().getTime();
                if (
                  nowTime < _this.listPromotionDesc.heraldTime ||
                  _this.listPromotionDesc.endTime < nowTime
                ) {
                  //预热期没到   活动已结束
                  _this.noActivity = true;
                }
              }
              if (_this.goodsDetail.limitWay == 0 || _this.goodsDetail.limitWay > 7) {
                // 不限购
                _this.prodCount = 1;
                _this.minNum = _this.goodsDetail.limitNum;
              } else if (_this.goodsDetail.limitWay == 4) {
                // 起售
                _this.minNum = _this.goodsDetail.limitNum;
              } else if (_this.goodsDetail.limitWay == 6) {
                _this.limit = true;
              }
              // 判断是否是农品
              if (
                _this.goodsDetail.listingTag &&
                ~_this.goodsDetail.listingTag.indexOf("1688")
              ) {
                _this.np = true;
              }
              // 判断是否是预售
              if (
                _this.goodsDetail.listingTag &&
                ~_this.goodsDetail.listingTag.indexOf("1662")
              ) {
                _this.ys = true;
              }
              // 如果是1808 不显示加购
              if (
                _this.goodsDetail.listingTag &&
                (~_this.goodsDetail.listingTag.indexOf("1808") || ~_this.goodsDetail.listingTag.indexOf("1662") )
              ) {
                _this.isShowCar = false;
              } else {
                _this.isShowCar = true;
                // 邮掌柜分享出来的vi页 不显示购物车
                if(_this.$route.query.shareId){
                  if(_this.$route.query.appName && _this.$route.query.appName == 'yzg'){
                    this.isShowCar = false;
                  }
                }
              }
              let params = {};
              if (_this.freshActType == "1") {
                params.cartType = "12";
              }
              checkCart(params, "jsonCallback").then((data) => {
                _this.cartNum = data.data;
                if (data.data === "0") {
                  _this.cartNum = null;
                }
              });
              _this.getKefu(
                _this.goodsDetail.uleStoreId,
                _this.goodsDetail.merchantId
              );
              // 判断优惠券类型是否存在
              if (_this.goodsDetail.listingTag) {
                if (
                  _this.goodsDetail.listingTag.indexOf("1705") > -1 ||
                  _this.goodsDetail.listingTag.indexOf("1706") > -1
                ) {
                  _this.activeListingTag = _this.goodsDetail.listingTag;
                }
              }
              if (
                !(
                  !_this.noActivity &&
                  (_this.goodsDetail.promotionIds.indexOf("6202") > -1 ||
                    _this.goodsDetail.promotionIds.indexOf("6203") > -1)
                )
              ) {
                //限时特价  新人礼特价  不支持优惠券
                let params = {
                  storeId: _this.goodsDetail.uleStoreId,
                  itemId: _this.goodsDetail.defItemId,
                  businessType: 4,
                  listingTag: _this.activeListingTag,
                }
                if(_this.freshActType == 1){
                  if(_this.$cookies.get("selectSite")){
                    let selectSite = JSON.parse(this.$cookies.get("selectSite"));
                    console.log(selectSite,'selectSite')
                    if(selectSite.adcode){
                      params.areaCode = selectSite.adcode;
                      params.cityCode = String(selectSite.adcode).slice(0, 4) + '00';
                      params.provinceCode = String(selectSite.adcode).slice(0, 2) + '0000';
                    }
                  }
                }
                queryCoupon(
                  params,
                  "jsonCallback"
                )
                  .then((res) => {
                    let data = {};
                    if (res.returnCode == "0000" || res.code == "0000") {
                      data = res.data;
                    }
                    let arr = [];
    
                    data.map((item) => {
                      let newObj = {
                        available: 1,
                        id: "", //优惠券 id
                        name: "", // 优惠券名称
                        condition: "", // 满减条件
                        description: "",
                        reason: "", // 不可用原因
                        value: null, // 折扣券优惠金额，单位分
                        startAt: null,
                        endAt: null,
                        valueDesc: "", // 折扣券优惠金额文案
                        unitDesc: "元", // 单位文案
                      };
                      switch (item.couponType) {
                        case "1":
                          item.type = "店铺券";
                          break;
                        case "2":
                          item.type = "商品券";
                          break;
                        case "3":
                          item.type = "运费券";
                          break;
                        case "4":
                          item.type = "充值券";
                          break;
                        case "5":
                          item.type = "通用券";
                          break;
                        case "6":
                          item.type = "品类券";
                          break;
                        case "7":
                          item.type = "跨店券";
                          break;
                        default:
                          item.type = "商品券";
                      }
                      if (item.isMultiStore == "true") {
                        item.type = "跨店券";
                      }
                      newObj.id = item.batchId;
                      newObj.name = item.remark || "优惠券名称";
                      // 添加新活动判断
                      if (
                        _this.goodsDetail.listingTag == null ||
                        _this.goodsDetail.listingTag == ""
                      ) {
                        newObj.condition =
                          item.fullCutAmount == 0
                            ? item.amount + "元,不限金额使用"
                            : "满" + item.fullCutAmount + "减" + item.amount;
                        item.desc =
                          item.fullCutAmount == 0
                            ? "不限金额使用"
                            : "满" + item.fullCutAmount + "减" + item.amount;
                      } else {
                        if (
                          _this.goodsDetail.listingTag.indexOf("1705") > -1 ||
                          _this.goodsDetail.listingTag.indexOf("1706") > -1
                        ) {
                          if (item.couponType == "7") {
                            newObj.condition =
                              item.fullCutAmount == 0
                                ? item.amount + "元,全站不限金额使用"
                                : "全站满" +
                                  item.fullCutAmount +
                                  "减" +
                                  item.amount;
                            item.desc =
                              item.fullCutAmount == 0
                                ? "全站不限金额使用"
                                : "全站满" +
                                  item.fullCutAmount +
                                  "减" +
                                  item.amount;
                            // newObj.condition = "全站满" + item.fullCutAmount + "减" + item.amount;
                            // item.desc = "全站满" + item.fullCutAmount + "减" + item.amount;
                          } else {
                            newObj.condition =
                              item.fullCutAmount == 0
                                ? item.amount + "元,不限金额使用"
                                : "满" + item.fullCutAmount + "减" + item.amount;
                            item.desc =
                              item.fullCutAmount == 0
                                ? "不限金额使用"
                                : "满" + item.fullCutAmount + "减" + item.amount;
                          }
                        } else {
                          newObj.condition = item.fullCutAmount == 0 ? item.amount + "元,不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                          item.desc = item.fullCutAmount == 0 ? "不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                        }
                      }
                      // newObj.condition = item.fullCutAmount == 0 ? "不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                      newObj.description = item.type;
                      newObj.reason = "";
                      newObj.value = item.amount * 100;
                      newObj.startAt = _this.$moment(item.expireBeginDate).format(
                        "X"
                      );
                      newObj.endAt = _this.$moment(item.expireEndDate).format("X");
                      newObj.valueDesc = item.amount;
                      newObj.couponWallFlag = item.couponWallFlag;
                      item.couponName = item.type;
                      arr.push(newObj);
                    });
                    _this.oldCouObj = data;
                    // console.log(data);
                    _this.coupons = arr;
                    let couponPopSetTime = _this.getViStorage;
                    if (couponPopSetTime.length > 0) {
                      let couponTime = 0;
                      _this.getViStorage.map((item) => {
                        if (item[_this.listingId]) {
                          couponTime = item[_this.listingId];
                        }
                        if (
                          _this.date - couponTime >= 7 &&
                          _this.coupons.length > 0
                        ) {
                          // 优惠券不显示时限超过七天后继续弹框
                          _this.showCouponList = true;
                          _this.couponPopTip = true;
                        } else {
                          _this.showCouponList = false;
                          _this.couponPopTip = false;
                        }
                      });
                    } else {
                      if (_this.coupons.length > 0) {
                        _this.showCouponList = true;
                        _this.couponPopTip = true;
                      } else {
                        _this.showCouponList = false;
                        _this.couponPopTip = false;
                      }
                    }
                  })
                  .then(() => {
                    _this.coupons.map(function(item, index) {
                      let coupon = document.querySelectorAll(".van-coupon")[index];
                      if (coupon && item.couponWallFlag == 2) {
                        coupon.classList.add("use-up");
                      }
                    });
                  });
              } else {
                // console.log(JSON.parse(_this.goodsDetail.listPromotionDesc));
                _this.$axios
                  .get("//clock.ule.com/now/?t=" + new Date().getTime())
                  .then((res) => {
                    _this.endTime = _this.listPromotionDesc.endTime;
                    _this.startTime = _this.listPromotionDesc.startTime;
                    _this.nowTime = res.data * 1000;
                    _this.countdownFn();
                    // console.log(res)
                  });
              }
              // 获取店铺信息
              storeDetail(_this.goodsDetail.uleStoreId, "jsonApiCallback").then(
                (res) => {
                  if (res.code === "0000") {
                    _this.storeInfo = res.data || {};
                  } else {
                    _this.$toast(res.returnMessage);
                  }
                }
              );
              if (_this.$route.query.shareId) {
                //神策埋点
                window.uleStatUtil &&
                  window.uleStatUtil.sendSensorTrack("ylxd_ShareClickSuccess", {
                    ylyx_shared_identify_key: "storeid", // 被分享用户  ID-key
                    ylyx_shared_identify_value:
                      _this.$route.query.storeid ||
                      _this.$route.query.store_id ||
                      "", // 被分享用户 ID-value
                    // exp_id: exp_id,
                    ylyx_share_channel: "微信好友", // 分享渠道
                    ylyx_share_content_type: "商品", // 分享内容类型
                    ylyx_share_content_name: _this.goodsDetail.listName, // 分享内容名称
                    item_id: _this.$route.params.listId, // 物品id
                    ylxd_share_content_id: _this.$route.query.shareId, // 分享内容 ID
                  });
              }
            }
          });
        })
      }else{
        getGoodsDetail(listingId).then((res) => {
          if (res.returnCode === "0000" || res.code === "0000") {
            this.shipTime = res.data.shipTime;
            let areaArr = JSON.parse(
              (res.data.saleRange || "[]").replace(/全部/g, "")
            );
            // console.log(areaArr);
            if (areaArr.length > 0) {
              areaArr.forEach((element) => {
                if (element.cityName) {
                  if (element.cityName.indexOf(element.provinceName) > -1) {
                    element.provinceName = "";
                  }
                  if (element.countryName) {
                    this.saleRangeList.push(
                      `${element.provinceName}${element.cityName}${element.countryName}`
                    );
                  } else {
                    this.saleRangeList.push(
                      `${element.provinceName}${element.cityName}`
                    );
                  }
                } else {
                  this.saleRangeList.push(element.provinceName);
                }
                // 	if (element.cityName.indexOf(element.provinceName) > -1) {
                // 		element.provinceName = "";
                // 		if (element.countryName) {
                // 			this.saleRangeList.push(`${element.provinceName}${element.cityName}${element.countryName}`);
                // 		} else {
                // 			this.saleRangeList.push(`${element.provinceName}${element.countryName}`);
                // 		}
                // 	} else {
                // 		this.saleRangeList.push(element.provinceName);
                // 	}
              });
              // console.log(this.saleRangeList);
            }
            let idArr = []; //商品促销标识集
            res.data.promotionList.map((item) => {
              idArr.push(item.id);
            });
            // if (~idArr.indexOf("50")) {
            //   // 团购
            //   location.href = `https://item.${this.$uleUrl()}/mitem/item/view/${listingId}`;
            // } else 
            if (~idArr.indexOf("46")) {
              // 秒杀
              location.href = `https://item.${this.$uleUrl()}/mitem/item/view/${listingId}`;
            }
            let data = res.data;
            this.goodsDetail = data;
            // this.paramsDesc = data.standardAttributeList ? JSON.parse(data.standardAttributeList) : [];
            // this.getStatement()
            this.getGoodsAssist(listingId, data,false);
            //神策埋点
            window.uleStatUtil &&
              window.uleStatUtil.sendSensorTrack("ylyx_CommodityDetailPageView", {
                item_id: data.listId,
                ylyx_commodity_name: data.listName,
                ylyx_commodity_original_price: data.sharePrice,
                ylyx_commodity_current_price: data.marketPrice,
              });
            document.title = this.goodsDetail.listName;
            if (this.goodsDetail.listPromotionDesc) {
              this.listPromotionDesc = JSON.parse(
                this.goodsDetail.listPromotionDesc
              );
              let nowTime = new Date().getTime();
              if (
                nowTime < this.listPromotionDesc.heraldTime ||
                this.listPromotionDesc.endTime < nowTime
              ) {
                //预热期没到   活动已结束
                this.noActivity = true;
              }
            }
            if (this.goodsDetail.limitWay == 0 || this.goodsDetail.limitWay > 7) {
              // 不限购
              this.prodCount = 1;
              this.minNum = this.goodsDetail.limitNum;
            } else if (this.goodsDetail.limitWay == 4) {
              // 起售
              this.minNum = this.goodsDetail.limitNum;
            } else if (this.goodsDetail.limitWay == 6) {
              this.limit = true;
            }
            // 判断是否是农品
            if (
              this.goodsDetail.listingTag &&
              ~this.goodsDetail.listingTag.indexOf("1688")
            ) {
              this.np = true;
            }
            // 判断是否是预售
            if (
              this.goodsDetail.listingTag &&
              ~this.goodsDetail.listingTag.indexOf("1662")
            ) {
              this.ys = true;
            }
            // 如果是1808 不显示加购
            if (
              this.goodsDetail.listingTag &&
              (~this.goodsDetail.listingTag.indexOf("1808") || ~this.goodsDetail.listingTag.indexOf("1662") )
            ) {
              this.isShowCar = false;
            } else {
              this.isShowCar = true;
              // 邮掌柜分享出来的vi页 不显示购物车
              if(this.$route.query.shareId){
                if(this.$route.query.appName && this.$route.query.appName == 'yzg'){
                  this.isShowCar = false;
                }
              }
            }
            let params = {};
            if (this.freshActType == "1") {
              params.cartType = "12";
            }
            checkCart(params, "jsonCallback").then((data) => {
              this.cartNum = data.data;
              if (data.data === "0") {
                this.cartNum = null;
              }
            });
            this.getKefu(
              this.goodsDetail.uleStoreId,
              this.goodsDetail.merchantId
            );
            // 判断优惠券类型是否存在
            if (this.goodsDetail.listingTag) {
              if (
                this.goodsDetail.listingTag.indexOf("1705") > -1 ||
                this.goodsDetail.listingTag.indexOf("1706") > -1
              ) {
                this.activeListingTag = this.goodsDetail.listingTag;
              }
            }
            if (
              !(
                !this.noActivity &&
                (this.goodsDetail.promotionIds.indexOf("6202") > -1 ||
                  this.goodsDetail.promotionIds.indexOf("6203") > -1)
              )
            ) {
              //限时特价  新人礼特价  不支持优惠券
              let params = {
                storeId: this.goodsDetail.uleStoreId,
                itemId: this.goodsDetail.defItemId,
                businessType: 4,
                listingTag: this.activeListingTag,
              }
              if(this.freshActType == 1){
                if(this.$cookies.get("selectSite")){
                  let selectSite = JSON.parse(this.$cookies.get("selectSite"));
                  console.log(selectSite,'selectSite')
                  if(selectSite.adcode){
                    params.areaCode = selectSite.adcode;
                    params.cityCode = String(selectSite.adcode).slice(0, 4) + '00';
                    params.provinceCode = String(selectSite.adcode).slice(0, 2) + '0000';
                  }
                }
              }
              queryCoupon(
                params,
                "jsonCallback"
              )
                .then((res) => {
                  let data = {};
                  if (res.returnCode == "0000" || res.code == "0000") {
                    data = res.data;
                  }
                  let arr = [];
  
                  data.map((item) => {
                    let newObj = {
                      available: 1,
                      id: "", //优惠券 id
                      name: "", // 优惠券名称
                      condition: "", // 满减条件
                      description: "",
                      reason: "", // 不可用原因
                      value: null, // 折扣券优惠金额，单位分
                      startAt: null,
                      endAt: null,
                      valueDesc: "", // 折扣券优惠金额文案
                      unitDesc: "元", // 单位文案
                    };
                    switch (item.couponType) {
                      case "1":
                        item.type = "店铺券";
                        break;
                      case "2":
                        item.type = "商品券";
                        break;
                      case "3":
                        item.type = "运费券";
                        break;
                      case "4":
                        item.type = "充值券";
                        break;
                      case "5":
                        item.type = "通用券";
                        break;
                      case "6":
                        item.type = "品类券";
                        break;
                      case "7":
                        item.type = "跨店券";
                        break;
                      default:
                        item.type = "商品券";
                    }
                    if (item.isMultiStore == "true") {
                      item.type = "跨店券";
                    }
                    newObj.id = item.batchId;
                    newObj.name = item.remark || "优惠券名称";
                    // 添加新活动判断
                    if (
                      this.goodsDetail.listingTag == null ||
                      this.goodsDetail.listingTag == ""
                    ) {
                      newObj.condition =
                        item.fullCutAmount == 0
                          ? item.amount + "元,不限金额使用"
                          : "满" + item.fullCutAmount + "减" + item.amount;
                      item.desc =
                        item.fullCutAmount == 0
                          ? "不限金额使用"
                          : "满" + item.fullCutAmount + "减" + item.amount;
                    } else {
                      if (
                        this.goodsDetail.listingTag.indexOf("1705") > -1 ||
                        this.goodsDetail.listingTag.indexOf("1706") > -1
                      ) {
                        if (item.couponType == "7") {
                          newObj.condition =
                            item.fullCutAmount == 0
                              ? item.amount + "元,全站不限金额使用"
                              : "全站满" +
                                item.fullCutAmount +
                                "减" +
                                item.amount;
                          item.desc =
                            item.fullCutAmount == 0
                              ? "全站不限金额使用"
                              : "全站满" +
                                item.fullCutAmount +
                                "减" +
                                item.amount;
                          // newObj.condition = "全站满" + item.fullCutAmount + "减" + item.amount;
                          // item.desc = "全站满" + item.fullCutAmount + "减" + item.amount;
                        } else {
                          newObj.condition =
                            item.fullCutAmount == 0
                              ? item.amount + "元,不限金额使用"
                              : "满" + item.fullCutAmount + "减" + item.amount;
                          item.desc =
                            item.fullCutAmount == 0
                              ? "不限金额使用"
                              : "满" + item.fullCutAmount + "减" + item.amount;
                        }
                      } else {
                        newObj.condition =
                          item.fullCutAmount == 0
                            ? item.amount + "元,不限金额使用"
                            : "满" + item.fullCutAmount + "减" + item.amount;
                        item.desc =
                          item.fullCutAmount == 0
                            ? "不限金额使用"
                            : "满" + item.fullCutAmount + "减" + item.amount;
                      }
                    }
                    // newObj.condition = item.fullCutAmount == 0 ? "不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                    newObj.description = item.type;
                    newObj.reason = "";
                    newObj.value = item.amount * 100;
                    newObj.startAt = this.$moment(item.expireBeginDate).format(
                      "X"
                    );
                    newObj.endAt = this.$moment(item.expireEndDate).format("X");
                    newObj.valueDesc = item.amount;
                    newObj.couponWallFlag = item.couponWallFlag;
                    item.couponName = item.type;
                    arr.push(newObj);
                  });
                  this.oldCouObj = data;
                  // console.log(data);
                  this.coupons = arr;
                  let couponPopSetTime = this.getViStorage;
                  if (couponPopSetTime.length > 0) {
                    let couponTime = 0;
                    this.getViStorage.map((item) => {
                      if (item[this.listingId]) {
                        couponTime = item[this.listingId];
                      }
                      if (
                        this.date - couponTime >= 7 &&
                        this.coupons.length > 0
                      ) {
                        // 优惠券不显示时限超过七天后继续弹框
                        this.showCouponList = true;
                        this.couponPopTip = true;
                      } else {
                        this.showCouponList = false;
                        this.couponPopTip = false;
                      }
                    });
                  } else {
                    if (this.coupons.length > 0) {
                      this.showCouponList = true;
                      this.couponPopTip = true;
                    } else {
                      this.showCouponList = false;
                      this.couponPopTip = false;
                    }
                  }
                })
                .then(() => {
                  this.coupons.map(function(item, index) {
                    let coupon = document.querySelectorAll(".van-coupon")[index];
                    if (coupon && item.couponWallFlag == 2) {
                      coupon.classList.add("use-up");
                    }
                  });
                });
            } else {
              // console.log(JSON.parse(this.goodsDetail.listPromotionDesc));
              this.$axios
                .get("//clock.ule.com/now/?t=" + new Date().getTime())
                .then((res) => {
                  this.endTime = this.listPromotionDesc.endTime;
                  this.startTime = this.listPromotionDesc.startTime;
                  this.nowTime = res.data * 1000;
                  this.countdownFn();
                  // console.log(res)
                });
            }
            // 获取店铺信息
            storeDetail(this.goodsDetail.uleStoreId, "jsonApiCallback").then(
              (res) => {
                if (res.code === "0000") {
                  this.storeInfo = res.data || {};
                } else {
                  this.$toast(res.returnMessage);
                }
              }
            );
            if (this.$route.query.shareId) {
              //神策埋点
              let _this = this;
              window.uleStatUtil &&
                window.uleStatUtil.sendSensorTrack("ylxd_ShareClickSuccess", {
                  ylyx_shared_identify_key: "storeid", // 被分享用户  ID-key
                  ylyx_shared_identify_value:
                    _this.$route.query.storeid ||
                    _this.$route.query.store_id ||
                    "", // 被分享用户 ID-value
                  // exp_id: exp_id,
                  ylyx_share_channel: "微信好友", // 分享渠道
                  ylyx_share_content_type: "商品", // 分享内容类型
                  ylyx_share_content_name: _this.goodsDetail.listName, // 分享内容名称
                  item_id: _this.$route.params.listId, // 物品id
                  ylxd_share_content_id: _this.$route.query.shareId, // 分享内容 ID
                });
            }
          }
        });
      }
    },
    getGoodsAssist(listingId, data,s) {
      let _this = this;
      let params =  { listId: listingId,listingTag:_this.goodsDetail.listingTag,itemId:_this.goodsDetail.defItemId };
      if(this.$browser().ylxdsq || this.$browser().ulemax){
        if(s){
          params.deliveryAreaId = this.$cookies.get("deliveryAreaId") || '';
        }
      }
      console.log('实时库存参数====',params,_this.goodsDetail)
      getGoodsAssist(
        params,
        "jsonCallback",
        "jsonCallback"
      ).then((results) => {
        data.colors.map((item, index) => {
          item.items.map((sItem, sindex) => {
            if (results.data) {
              results.data.item.forEach((el) => {
                if (el.itemId == sItem.itemId) {
                  sItem.itemStorage = el.itemStorage;
                  if(!/2084/.test(_this.goodsDetail.listingTag)){
                    sItem.itemSalPrice = el.salePrice;
                  }
                }
              });
            }
            if (sItem.itemId == data.defItemId) {
              this.active = index;
              this.sizeActive = sindex;
            }
          });
        });
        this.storage = this.goodsDetail.colors[this.active]["items"][
          this.sizeActive
        ]["itemStorage"];
        this.colorName = this.goodsDetail.colors[this.active]["colorName"];
        this.sizeName = this.goodsDetail.colors[this.active]["items"][
          this.sizeActive
        ]["attrName"];
        // 初始banner img
        this.bannerImages = this.goodsDetail.colors[this.active]["items"][
          this.sizeActive
        ]["imageList"];
        if (
          !this.noActivity &&
          (this.goodsDetail.promotionIds.indexOf("6202") > -1 ||
            this.goodsDetail.promotionIds.indexOf("6203") > -1)
        ) {
          //限时特价  新人礼特价
          this.price = this.goodsDetail.colors[this.active]["items"][
            this.sizeActive
          ].membershipPrice;
        } else {
          this.price = this.goodsDetail.colors[this.active]["items"][
            this.sizeActive
          ].itemSalPrice;
        }
        // this.makePrice = (Number(this.goodsDetail.commission) - Number((this.goodsDetail.saleCommission || 0))).toFixed(2);
        if(this.goodsDetail.shareCommission > 0){
          this.makePrice = this.goodsDetail.shareCommission
        }else{
          this.makePrice = this.goodsDetail.commission || 0;
        }
        console.log('佣金=====',this.makePrice)
        this.mkPrice = this.goodsDetail.marketPrice;
        this.shareImg = this.goodsDetail.imgUrl;
        this.getAppShareURL();
      });
    },
    getAppShareURL() {
      // 获取分享id
      getAppShareURL(
        {
          clientCallType: "H5",
          data: JSON.stringify({
            shareChannel: "1",
            shareFrom: "0",
            listInfo: [
              {
                listId: this.listingId,
                sharePrice: this.price,
                marketPrice: this.mkPrice,
                freshActType: this.freshActType || "",
                shareFrom: "0",
              },
            ],
          }),
        },
        "jsoncallback"
      ).then((res) => {
        if (res.returnCode === "0000" || res.code === "0000") {
          this.shareId = res.data.shareId;
          if (this.$browser().miniprogram) {
            //神策埋点
            window.uleStatUtil &&
              window.uleStatUtil.sendSensorTrack("ylyx_ShareResult", {
                ylyx_event_share_id: this.shareId || "",
                ylyx_event_sharer_id:
                  this.$route.query.store_id ||
                  this.$route.query.storeid ||
                  this.getStorage("user", "user.STORE_ID") ||
                  "",
                ylyx_share_channel: "小程序",
                ylyx_share_content_type: "商品",
                ylyx_share_content_name: this.goodsDetail.listName,
                item_id: this.goodsDetail.listId,
                ylyx_commodity_current_price: this.goodsDetail.marketPrice,
                ylyx_commodity_original_price: this.goodsDetail.sharePrice,
                ylyx_share_content_id: this.goodsDetail.listId,
              });
            let data = {
              title: this.goodsDetail.listName,
              desc: this.goodsDetail.listPromotionName,
              link: this.getCurrentLink(location.href, this.freshActType),
              imgUrl: this.creatbanner[0],
            };
            window.wx.miniProgram.postMessage({
              data: data,
            });
            if (this.freshActType == 1) {
              html2canvas(this.$refs.cardCon, {
                // width:100,
                // hreight:100,
                backgroundColor: null, //画出来的图片有白色的边框，不要可设置背景为透明色(null)
                useCORS: true, //支持图片跨域
                scale: 1, //设置放大的倍数
              }).then((canvas) => {
                let url = canvas.toDataURL("image/png"); //toDataURL 图片格式转成base64
                this.$axios({
                  method: "POST",
                  url: `https://m.${this.$uleUrl()}/wxminiapp/user/wx/upWxMaterial`,
                  withCredentials: true,
                  data: Qs.stringify({
                    imgData: url.split("data:image/png;base64,")[1],
                  }),
                }).then((res) => {
                  this.shareTitle = data.title =
                    "今日好价，快来抢！" + this.goodsDetail.listName;
                  data.imgUrl = res.data.data;
                  this.shareImg = res.data.data;
                  window.wx.miniProgram.postMessage({
                    data: data,
                  });
                });
              });
            }
          } else {
            window.setWeiXinShare({
              title: this.goodsDetail.listName,
              desc: this.goodsDetail.listPromotionName,
              link: this.getCurrentLink(location.href, this.freshActType),
              imgUrl: this.creatbanner[0],
            });
            //神策埋点
            window.uleStatUtil &&
              window.uleStatUtil.sendSensorTrack("ylyx_ShareResult", {
                ylyx_event_share_id: this.shareId || "",
                ylyx_event_sharer_id:
                  this.$route.query.store_id ||
                  this.$route.query.storeid ||
                  this.getStorage("user", "user.STORE_ID") ||
                  "",
                ylyx_share_channel: "微信好友",
                ylyx_share_content_type: "商品",
                ylyx_share_content_name: this.goodsDetail.listName,
                item_id: this.goodsDetail.listId,
                ylyx_commodity_current_price: this.goodsDetail.marketPrice,
                ylyx_commodity_original_price: this.goodsDetail.sharePrice,
                ylyx_share_content_id: this.goodsDetail.listId,
              });
          }
        } else {
          this.shareId = "";
        }
        this.shareBtnStatus = false;
      });
    },
    //倒计时
    countdownFn() {
      let timer = setInterval(() => {
        let t;
        if (this.startTime > this.nowTime) {
          this.isActivityStart = false;
          t = this.startTime - this.nowTime;
        } else {
          this.isActivityStart = true;
          t = this.endTime - this.nowTime;
        }
        if (t > 0) {
          let hour = Math.floor((t / 3600000) % 24) || 0;
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          let format = "";
          format = `${hour}:${min}:${sec}`;
          this.countdown = format;
          this.nowTime += 1000;
        } else {
          clearInterval(timer);
          this.countdown = "00:00:00";
        }
      }, 1000);
    },
    //
    showCoupon() {
      this.showCouponList = true;
      setTimeout(() => {
        this.coupons.map((item, index) => {
          let coupon = document.querySelectorAll(".van-coupon")[index];
          if (coupon && item.couponWallFlag == 2) {
            coupon.classList.add("use-up");
          }
        });
      }, 100);
    },
    // 加入购物车
    adCart() {
      let data = {
        listId: this.listingId,
        itemId: this.goodsDetail.defItemId,
        itemCount: this.prodCount,
        yxdId: this.store_id || this.getStorage("user", "user.STORE_ID") || '', // 用户id
        itemTrack: JSON.stringify({locationld:"wap",uid:this.union_id,uref: this.union_ref})    
      };
      if (this.freshActType == 1) {
        data.cartType = "12";
      }
      if(this.$browser().ylxdsq || this.$browser().ulemax){
        let _this = this;
        window.dsBridge.call("getPilotStatus", {
          ios_action: "getPilotStatusResult",
          android_action: "getPilotStatusResult",
        });
        window.dsBridge.register("getPilotStatusResult", function(s) {
          console.log('加购ssssss======',s)
          if (s) {
            data.cartType = "12";
            data.deliveryAreaId = _this.$cookies.get("deliveryAreaId") || '';
          }
          console.log('加购参数data===',data)
          adCart(data, "jsonCallback").then((res) => {
            if (res.returnCode === "0000" || res.code === "0000") {
              _this.cartNum = res.data;
              if (res.data === "0") {
                _this.cartNum = null;
              }
            }
            _this.$toast(res.returnMessage);
          });
        })
      }else{
        adCart(data, "jsonCallback").then((res) => {
          if (res.returnCode === "0000" || res.code === "0000") {
            this.cartNum = res.data;
            if (res.data === "0") {
              this.cartNum = null;
            }
          }
          this.$toast(res.returnMessage);
        });
      }
      //神策埋点
      window.uleStatUtil &&
        window.uleStatUtil.sendSensorTrack("ylyx_AddCart", {
          ylyx_commodity_sku_code: this.goodsDetail.defItemId,
          ylyx_commodity_name: this.goodsDetail.listName,
          ylyx_commodity_original_price:
            this.ylyx_commodity_original_price || this.goodsDetail.marketPrice,
          ylyx_commodity_current_price:
            this.ylyx_commodity_current_price || this.goodsDetail.sharePrice,
          item_id: this.listingId,
          ylyx_commodity_count: this.prodCount,
        });
    },
    getComment(listingId) {
      let data = {
        listingId: listingId,
        pageNum: 1,
        pageSize: 10,
        commentImgFlag: 0, // 0-全部 1-图片
      };
      let currentVal = `jsonp${30 + this.jsonpNum}`;
      getComments(data, currentVal)
        .then((res) => {
          if (res.data) {
            this.comments = res.data.list;
            this.comLoading = false;
          }
        })
        .catch((err) => {
          console.log("err===", err);
        });
    },
    // 获取客服状态
    // checkState() {
    // 	if (!this.serviceState) {
    // 		this.$toast("客服不在线");
    // 	}
    // },
    // 获取客服
    getKefu(storeId, merchantId) {
      this.$axios
        .post(
          `//livechat.${this.$uleUrl()}/uleImService/imService/custServOnlineStatu`,
          {
            storeId: storeId,
            merchantId: merchantId,
            source: "item",
          }
        )
        .then((res) => {
          let data = res.data;
          if (data.returnCode === "0000" || data.code === "0000") {
            switch (data.data.status) {
              case "offline":
                this.serviceState = false; // 不在线
                this.serviceUrl = `https://livechat.${this.$uleUrl()}/imweb/visitorBusinessMobile?channel=yxdsq&source=item&merchantId=${merchantId}&storeId=${storeId}&itemId=${
                  this.listingId
                }`;
                break;
              case "online":
                this.serviceState = true; // 在线
                this.serviceUrl = `https://livechat.${this.$uleUrl()}/imweb/visitorBusinessMobile?channel=yxdsq&source=item&merchantId=${merchantId}&storeId=${storeId}&itemId=${
                  this.listingId
                }`;
                break;
              default:
            }
          }
        });
    },
    // 立即购买
    buy() {
      console.log(this.targetUrl,this.$route.fullPath)
      if (this.isLogin) {
        console.log('freshActType====',this.freshActType)
        console.log('this.$route.fullPath===',this.$route.fullPath)
        let url = this.$route.fullPath;
        let successBack = encodeURIComponent(url);
        this.$cookies.set('successBack', successBack, 14 * 24 * 3600, '/', '.'+ this.$uleUrl());
        this.$refs.orderForm.submit();
        //神策埋点
        let price =
          this.ylyx_commodity_current_price || this.goodsDetail.sharePrice;
        let amount = Number(this.prodCount) * Number(price);
        window.uleStatUtil &&
          window.uleStatUtil.sendSensorTrack("ylyx_SettleClick", {
            ylyx_operation_type: "立即购买",
            ylyx_commodity_sku_code_list: [this.goodsDetail.defItemId],
            ylyx_commodity_total_amount: amount.toFixed(2),
          });
      } else {
        this.handleToLogin();
      }
    },
    handleToLogin() {
      this.targetUrl = `${this.targetUrl}${this.$route.fullPath}`;
      this.$dialog
        .confirm({
          title: "提示",
          message: "请先登录",
        })
        .then(() => {
          if (this.$browser().miniprogram) {
            window.wx.miniProgram.navigateTo({
              url:
                "/pages/authorize?target=" +
                encodeURIComponent(this.targetUrl) +
                "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
            });
          } else {
            window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(
              this.targetUrl
            )}`;
          }
        })
        .catch(() => {});
    },
    tocart() {
      if (this.freshActType == "1") {
        this.$router.push({
          path: "/cart/cartList",
          query: {
            name: this.$route.query.name,
            latng: this.$route.query.latng,
            addr: this.$route.query.addr,
            city: this.$route.query.city,
            module: this.$route.query.module,
            freshActType: this.freshActType,
          },
        });
      } else {
        this.toNext("/cart/cartList");
      }
    },
    // 分享
    share() {
      this.shareBtnStatus = true; // 点击分享后暂时disabled按钮防止重复点击
      this.goodsShare(
        this.shareTitle || this.goodsDetail.listName,
        this.goodsDetail.listName,
        location.href,
        this.shareImg,
        this.listingId,
        this.price,
        this.mkPrice,
        this.freshActType,
        {
          isCreateShareWXMini: true,
          label: "到手价",
          title: "今日好价，快来抢！" + this.goodsDetail.listName,
        }
      );
      setTimeout(() => {
        // 2s后恢复分享按钮点击
        this.shareBtnStatus = false;
      }, 1000);
    },
    // 获取优惠券信息
    getCoupon(getCouponData, index) {
      // 已登录
      if (this.$cookies.get("mall_cookie")) {
        getCoupon(getCouponData, "jsonCallback").then((res) => {
          if (res.returnCode == "0000" || res.code == "0000") {
            this.$toast("领取成功");
            this.disabledCoupons.push(this.coupons[index]);
            this.coupons.splice(index, 1);
            // this.chosenCoupon = index;
          } else if (res.returnCode == "2014") {
            this.$toast(res.returnMessage);
          } else {
            this.$toast("领取优惠券失败");
          }
        });
      }
      // 未登录
      else {
        let targetUrl = `https://h5.${this.$uleUrl()}/yxd/community`;
        targetUrl = `${targetUrl}${this.$route.fullPath}`;
        // console.log(this.$route.fullPath);
        // console.log(targetUrl);
        this.$dialog
          .confirm({
            title: "提示",
            message: "请先登录",
          })
          .then(() => {
            if (this.$browser().miniprogram) {
              window.wx.miniProgram.navigateTo({
                url:
                  "/pages/authorize?target=" +
                  encodeURIComponent(targetUrl) +
                  "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
              });
            } else {
              window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(
                targetUrl
              )}`;
            }
          })
          .catch(() => {
            this.active = 0;
          });
      }
    },
    viPageBack() {
      console.log('document.referrer==',document.referrer)
      console.log('this.$route.query==',this.$route.query)
      if ((this.$browser().ylxdsq || this.$browser().ulemax) && document.referrer) {
        //其他来源返回处理
        this.$router.go(-1);
      } 
      else if(this.$route.query.pageFrome == 'limit'){
        // 秒杀列表页过来
        this.$router.go(-1);
      }
      else if (this.$browser().ylxdsq || this.$browser().ulemax) {
        if (window.history.length <= 1) {
          // 如果是小店社区APP
          if (navigator.userAgent.indexOf("Android") > -1) {
            location.href = "ulemobile://ulePopView";
          } else {
            location.href = "objc:ulemobile://ulePopView";
          }
          return false;
        } else {
          //其他页面到的vi页
          this.$router.go(-1);
        }
        // 处理路由里返回到vi页的问题
        //如果上面都执行了 页面都跳走了，这个也就不用管了
        setTimeout(() => {
          // 如果是小店社区APP
          if (navigator.userAgent.indexOf("Android") > -1) {
            location.href = "ulemobile://ulePopView";
          } else {
            location.href = "objc:ulemobile://ulePopView";
          }
        }, 500);
      }
      else if(this.$browser().yzg){
        location.href = "ulemobile://ulePopView";
      }
       else if (
        (this.$browser().wx || this.$browser().miniProgram) &&
        this.$route.query.shareId
      ) {
        this.toNext("/");
      } else {
        this.$router.go(-1);
      }
    },
    appGetPioltFlag() {
      let query = {
        clientCallType: "h5",
        pageIndex: 1,
        pageSize: 10,
        keyword: this.$route.params.listId,
        area: "global",
      };
      dsBridge.call("getPilotStatus", {
        ios_action: "getPilotStatusResult",
        android_action: "getPilotStatusResult",
      });
      dsBridge.register("getPilotStatusResult", (s) => {
        if (typeof s == "string") {
          s = JSON.parse(s);
        }
        console.log('sssssssssss=1',s)
        console.log('query',query)
        if (s) {
          this.freshActType = "1";
          document.cookie = `ispioltCity=1;domain=.${this.$uleUrl()};path=/;expires=3600`;
          query.listingTags = '1784';
        }
        findListing(query).then((res) => {
          console.log("res", res);
          if (res.returnCode == "0000") {
            if (res.data.Listings && res.data.Listings.length > 0) {
              this.canBuy = true;
              console.log("可以购买");
            } else {
              this.canBuy = false;
              console.log("不能购买");
            }
          }
        });
      });
    },
    //企业微信环境动态加载企业微信jssdk
    loadWxJs() {
      // 创建script标签，引入外部文件
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "//i0.ulecdn.com/app/yxd/j/yl/jweixin-1.0.0.js";
      document.getElementsByTagName("head")[0].appendChild(script);
      // 引入成功
      script.onload = function() {
        console.log("企微jssdk已加载成功了");
      };
      // 引入失败
      script.onerror = function() {
        console.log("企微jssdk资源加载失败了");
      };
    },
    //获取浮层展示数据
    get919Data(){
      viPopFor919Api({ visualChannel: 'wap_ylxdsq' }).then(res => {
        console.log('===res',res)
        if (res.code == '0000') {
          if (res.content) {
            this.hd919Data = res.content[0];
            this.sendTrack('resourceExposure',res.content[0] || {})
          } else {
            this.hd919Data = '';
          }
        } else {
          this.hd919Data = '';
        }
      });
    },
    // 浮层点击
    handleTo919Link() {
      if (this.hd919Data.act_type == "20" && this.freshActType != "1") {
        // 红包抽奖 非试点
        this.showRed = true
        this.sendTrack('resourceClick',this.hd919Data)
        console.log('抽奖', this.showRed)
      } else if (this.hd919Data.h5_url) {
        let storeid = this.$route.query.storeid || this.$route.query.store_id
        if (storeid) {
          if (this.hd919Data.h5_url.indexOf('?') > -1) {
            this.hd919Data.h5_url = `${this.hd919Data.h5_url}&storeid=${storeid}&shareId=${this.$route.query.shareId}`;
          } else {
            this.hd919Data.h5_url = `${this.hd919Data.h5_url}?storeid=${storeid}&shareId=${this.$route.query.shareId}`;
          }
        }
        console.log('跳转链接=====', this.hd919Data.h5_url);
        location.href=this.hd919Data.h5_url;
      }
    },
    sendTrack(event,item) {
      console.log('item====',item)
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack(event, {
        ule_title: '商品详情页面',
        resource_type: '浮标',
        resource_name: '商品详情页-浮标',
        resource_content: 0,
        resource_item_type: '活动',
        resource_item_id: '',
        resource_forward_url: '',
        // ul_aid: ':uxvi_float',
        ul_aid:`yxvi_float_${item.title || ''}`
      });
    },
    isPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod","IEMobile","mobile","blackberry","webos","incognito","webmate"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
              flag = false;
              break;
          }
      }
      return flag;
    },

    goCredentialPage () {
      location.href = `https://www.${this.$uleUrl()}/ulewap/store/storeInfo.html?storeId=${this.goodsDetail.uleStoreId}`
    }
  },
  created() {
    window.addEventListener("resize", this.resizeEvent, true);
    this.date = this.$moment(Date.now()).format("YYYYMMDD");
    this.isLogin =
      this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")
        ? true
        : false;
        console.log('login:',this.isLogin)
    if(this.isLogin) {
      // this.getRainFloat();
    } else {
      this.get919Data();//获取浮层展示数据
    }
  },
  mounted() {
    console.log('isPC2',this.isPC())
    console.log(this.$cookies.get('ul_adid'),'=====adid====')
    this.adid = this.$cookies.get('ul_adid') || '';
    if(this.isPC()){
      this.isShowPc = true;
    }
    this.$cookies.remove('successBack','/', '.'+ this.$uleUrl());
    this.freshActType =
      this.$route.query.freshActType || this.$cookies.get("ispioltCity");
    if (this.freshActType == "1") {
      document.cookie = `ispioltCity=1;domain=.${this.$uleUrl()};path=/;expires=3600`;
      this.showActBanner = false;
    } else {
      this.isShowFloatStrip = true;
    }
    if (this.$route.query.ul_sch || this.$route.query.client_type) {
      this.client_type =
        this.$route.query.ul_sch || this.$route.query.client_type;
    } else {
      this.client_type =
        this.$cookies.get("ul_sch") || this.$cookies.get("client_type");
    }
    console.log('client_type=====',this.client_type)
    if(this.$browser().ylxdsq){
      setTimeout(() => {
        if(this.freshActType != "1"){ //非试点
          this.actBanner()
        }
      },1000)
    }
    // 邮乐优鲜app 或 邮掌柜app
    if (this.$browser().ylxdsq || this.$browser().yzg || this.$browser().ulemax) {
      console.log('设置app头')
       // 小店去掉原生头
       window.dsBridge &&
       window.dsBridge.call("setNativeTitle", {
         title: "",
       });
      // 获取定位
      if (this.$browser().ios && this.$browser().version >= 244) {
        this.appGetPioltFlag();
      } else if (this.$browser().android && this.$browser().version >= 242) {
        this.appGetPioltFlag();
      }
      // this.appFloatStrip();
      this.deliveryAreaId = this.$cookies.get("deliveryAreaId") || '';
      // 获取分佣金额
       console.log('请求接口获取分佣金额')
    } else {
      // 判断是否分享
      if (this.$route.query.shareId) {
        // 邮掌柜分享出来的vi页 不显示购物车
        if(this.$route.query.appName && this.$route.query.appName == 'yzg'){
          this.isShowCar = false;
        }
        let teamUserId =
          this.$route.query.storeid || this.$route.query.store_id;
        // console.log('storeId=====',teamUserId)
        let params = {
          teamId: 2,
          siteType: 2,
          teamUserId,
        };
        // 获取分享人的自提点
        pilotCityList(params).then((res) => {
          // console.log('res====',res)
          let currentSite = {};
          if (res.returnCode == "0000" && res.data) {
            currentSite = res.data.result[0];
            // console.log('默认自提点',currentSite)
            let params = {
              consigneeName: currentSite.consigneeName,
              mobileNum: currentSite.mobileNum,
              siteId: currentSite.siteId,
            };
            // 存入cookies下单用
            let selectSite = {
              location: currentSite.geoPoint,
              siteId: currentSite.siteId,
              adcode: currentSite.areaId,
              mobileNum: currentSite.mobileNum,
              consigneeName: currentSite.consigneeName,
            };
            // console.log('selectSite====',selectSite)
            document.cookie = `selectSite=${JSON.stringify(
              selectSite
            )};domain=.${this.$uleUrl()};path=/;expires=3600`;
            console.log("params===", params);
            addOrUpdateApi(params).then((res) => {
              // console.log('res===',res)
              console.log("自提点更新成功");
            });
          } else {
            console.log("团长无自提点");
          }
        });
      }
    }
    // if (this.$browser().miniprogram) {
    // 	// 优鲜小程序
    // 	this.client_type = "miniwx_ylxdsq";
    // 	this.iswxMiniprogram = true;
    // } else if (this.$browser().ylxdsq) {
    // 	// 优鲜app
    // 	this.client_type = "app_ylxdsq";
    // 	// 小店去掉原生头
    // 	window.dsBridge &&
    // 		window.dsBridge.call("setNativeTitle", {
    // 			title: "",
    // 		});
    // } else if (this.$browser().yzgxd) {
    // 	// 邮掌柜小店 app
    // 	this.client_type = "app_yzgxd";
    // } else {
    // 	this.client_type = "wap_ylxdsq";
    // }

    // 直播渠道判断
    let union_id = this.$route.query.union_id,
      union_ref = this.$route.query.union_ref;
    if (union_id && union_ref) {
      this.union_id = union_id;
      this.union_ref = union_ref;
    }
    this.resizeEvent();
    this.uleUrl = this.$uleUrl();
    this.listingId = this.$route.params.listId;
    this.getShareId = this.$route.query.shareId || "";
    this.store_id =
      this.$route.query.store_id ||
      this.$route.query.storeid ||
      // this.getStorage("user", "user.STORE_ID") ||
      "";
    if (~(this.store_id + "").indexOf("=")) {
      //处理已产生的store_id 带等号的问题
      this.store_id = this.store_id.split("=")[1];
    }
    if (this.store_id === "false") {
      //处理已产生的store_id 等于'false' 的问题
      this.store_id = "";
    }
    console.log('freshActType====',this.freshActType);
    let params = {
      deliveryAreaId:this.$cookies.get("deliveryAreaId") || '',
      listingId:this.listingId
    }
    this.getGoodsDetail(this.listingId,params);
    getGoodsInfo(this.listingId).then((res) => {
      if ((res.returnCode === "0000" || res.code === "0000") && res.data) {
        let img1 = "//pic.ulecdn.com/m/pic/user_800109780/product/prd20230630/0bd6b4f552a4a2f9_p750x972.jpg";
        let img2 = "//pic.ulecdn.com/m/pic/user_800109780/product/prd20230630/5a197ab7641e8aae_p750x1917.jpg";
        let img3 = "//pic.ulecdn.com/m/pic/user_800109780/product/prd20230630/15483145623938a1_p750x884.jpg";
        if(process.env.NODE_ENV === "testing"){
          img1 = '//pic.testing.ulecdn.com/m/pic/user_800152600/product/prd20230714/c1a527f4d71b61ec_p750x972.jpg'
        }
        console.log('this.freshActType',this.freshActType)
        if (res.data.indexOf("aftersalesImg") > -1 && this.freshActType == 1 && (this.$browser().ylxdsq || this.$browser().ulemax)) {
          console.log("进来了");
          res.data = res.data.replace(img1, "");
          res.data = res.data.replace(img2, "");
          res.data = res.data.replace(img3, "");
        }
        this.goodsDesc = res.data
          .replace(/src/g, "load-src")
          .replace(/data-original/g, "src");
      }
    });
    this.getComment(this.listingId);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("resize", this.resizeEvent);
    });

  },
};
